var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticStyle:{"font-size":"20px","font-weight":"bold"}},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }